import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Honorific } from '../../types/api/graphql';

export const useHealthProfessionalHonorificValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      Object.values(Honorific).map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.honorific.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};
